import Page from '../../page';
import SimpleSharePopin from '../../../helpers/simple-share-popin';

export default class NewsEntry extends Page {
    constructor(...args) {
        super(...args);

        this._retrieveDOM();
        this._initTls();

        this.dom.socials = this.dom.page.querySelectorAll('[data-social]');
        new SimpleSharePopin(this.dom.socials);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/news/entry/news-entry.js